const itemDataTemplate = (
  { productId, productCode, variantId, brand, colour, title, price, variants },
  index = 0
) => {
  const getSize = () => {
    const selectedVariant = variants?.find(({ id }) => id === variantId);

    return selectedVariant ? selectedVariant.size : undefined;
  };

  const { xrp, current } = price;

  const item = {
    productId: productId ? String(productId) : undefined,
    productCode: String(productCode),
    variantId: variantId ? String(variantId) : undefined,
    item_name: title,
    index: index + 1,
    item_brand: brand,
    price: xrp?.value || undefined,
    priceLocalCurrency: current.value,
    quantity: 1,
    size: getSize(),
    item_variant: colour || undefined,
    google_business_vertical: "retail"
  };

  return item;
};

export default itemDataTemplate;
